import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { SubHeaderComponent } from './sub-header'
import { notify } from './notify'
import * as history from '../history'
import * as bookmark from '../bookmark'
import { PublisherDisplayStr, PublisherStr } from '../../../common/define'

// historyLinkProps 는 글을 여는 링크에 열람 기록을 붙인다. 세 화면이 같은 두 줄을 쓰므로 한
// 곳에 둔다. 컴포넌트 계층에 두는 이유는 history.js 가 React 이벤트 이름과 마우스 버튼 번호를
// 몰라야 하기 때문이다.
// 잡히는 경로는 좌클릭·터치·Enter·Ctrl/Cmd+클릭·가운데 클릭이다. 컨텍스트 메뉴로 여는 것은
// 잡지 않는다 — 메뉴가 열린 것은 알 수 있어도 거기서 실제로 열었는지는 알 수 없어, 잡으려
// 들면 열지 않은 글까지 쌓인다.
export function historyLinkProps(post) {
  return {
    onClick: () => history.add(post),
    onAuxClick: e => {
      if (e.button === 1) {
        history.add(post)
      }
    },
  }
}

@observer
export class HistoryPostsComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cachedPosts: history.list(),
      query: '',
    }
  }

  // 읽기·쓰기 실패는 화면이 없는 시점에 일어나 그 자리에서 알릴 수 없다. 여기서 받아 알린다.
  componentDidMount() {
    if (history.wasBroken()) {
      notify('봤던글 목록이 깨져 있어 새로 시작합니다', 'warning')
    }
    if (history.takeWriteFailed()) {
      notify('저장 공간이 부족해 최근 본 글이 기록되지 않았습니다', 'danger')
    }
  }

  refresh() {
    this.setState({ cachedPosts: history.list() })
  }

  onDelete(post) {
    try {
      history.del(post)
    } catch (e) {
      notify('저장 공간이 부족해 지우지 못했습니다', 'danger')
      return
    }
    this.refresh()
  }

  closeModal() {
    if (window.UIkit && window.UIkit.modal) {
      const modal = window.UIkit.modal('#history-io-modal')
      if (modal) {
        modal.hide()
      }
    }
  }

  onReset() {
    const n = history.count()
    if (n <= 0) {
      notify('비울 목록이 없어요', 'warning')
      return
    }
    // 계속 쓰면 다시 쌓이지만 지금 목록은 못 되돌리므로 확인을 받는다.
    if (!window.confirm(`봤던글 ${n}개를 모두 지웁니다. 계속할까요?`)) {
      return
    }
    try {
      history.clear()
    } catch (e) {
      notify('저장 공간이 부족해 비우지 못했습니다', 'danger')
      return
    }
    this.refresh()
    notify(`${n}개를 지웠습니다`, 'success')
    this.closeModal()
  }

  render() {
    const query = this.state.query.trim()
    const posts = query
      ? this.state.cachedPosts.filter(post => post.subject.includes(query))
      : this.state.cachedPosts
    return (
      <div id="history">
        <SubHeaderComponent isHistory={true} />

        {/* 다시보기와 같은 자리에 같은 모양으로 둔다. */}
        <div className="uk-flex uk-flex-right uk-margin-small-top uk-margin-small-bottom">
          <button className="uk-button uk-button-default uk-button-small" type="button"
            uk-toggle="target: #history-io-modal">목록 관리</button>
        </div>

        {/* 검색어는 기억나는 몇 글자면 충분하다. 입력칸을 폭 가득 늘리면 그만큼 길게 쳐야
            할 것처럼 보인다. 위 탭 줄과 비슷한 폭으로 맞추고 가운데 정렬한다. 좁은 화면에서는
            입력칸만 줄어든다. */}
        <div className="uk-flex uk-flex-center uk-margin-small-bottom">
          <input className="uk-input uk-form-small" type="text" placeholder="제목으로 찾기"
            style={{ flex: '0 1 20em' }}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })} />
        </div>

        <ul className="uk-list uk-list-divider uk-text-middle">
          {
            posts.map(post =>
              <li className="post" key={post.url}>
                <HistoryPostComponent post={post} onDelete={() => this.onDelete(post)} />
              </li>)
          }
          {
            posts.length <= 0 &&
            <div className="uk-text-center uk-margin">{query ? '찾는 글이 없어요' : 'no data'}</div>
          }
        </ul>

        {/* 다시보기와 같은 자리에 같은 이름으로 둔다. 조작이 하나뿐이라 모달이 과해 보이지만,
            목록을 통째로 지우는 버튼을 화면에 그대로 노출하지 않는 값이 더 크다.
            이 모달은 상태를 갖지 않는다 — 열고 닫는 것 말고 기억할 게 없다. */}
        <div id="history-io-modal" uk-modal="uk-modal">
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
            <button className="uk-modal-close-default" type="button" uk-close="uk-close" />
            <h3 className="uk-modal-title">봤던글 목록 관리</h3>
            <button className="uk-button uk-button-danger uk-button-small" type="button"
              onClick={() => this.onReset()}>목록 비우기</button>
          </div>
        </div>
      </div>
    );
  }
}

@observer
export class HistoryPostComponent extends Component {
  onBookmark() {
    try {
      if (bookmark.has(this.props.post)) {
        bookmark.del(this.props.post)
      } else {
        bookmark.add(this.props.post)
      }
    } catch (e) {
      notify('저장 공간이 부족해 다시보기 목록을 저장하지 못했습니다', 'danger')
    }
  }

  // 삭제 아이콘은 배지 뒤 맨 끝에 둔다. 북마크 옆에 붙이면 보관하려다 지우는 오탭이 나는데,
  // 그건 되돌릴 방법이 없다.
  render() {
    return (
      <div className="uk-flex uk-flex-middle">
        <a
          className="post-body uk-link-text uk-text-truncate uk-text-normal"
          href={this.props.post.url}
          style={{ flexGrow: 1 }}
          {...historyLinkProps(this.props.post)}>
          {this.props.post.subject}
        </a>
        <a
          className={`bookmark-icon ${bookmark.has(this.props.post) ? 'bookmarked' : 'not-bookmarked'} uk-icon-button uk-text-light uk-text-center uk-text-middle`}
          uk-icon="bookmark"
          style={{ flexShrink: 0, width: '2em', height: '2em' }}
          onClick={() => this.onBookmark()} />
        <span
          className={`badge-${PublisherStr[this.props.post.publisher]} uk-badge uk-text-nowrap uk-text-small uk-text-light`}
          style={{ marginLeft: '0.2em', flexShrink: 0 }} >
          {PublisherDisplayStr[this.props.post.publisher]}
        </span>
        <a
          className="uk-icon-button uk-text-light uk-text-center uk-text-middle"
          uk-icon="trash"
          style={{ flexShrink: 0, width: '2em', height: '2em', marginLeft: '0.2em' }}
          onClick={() => this.props.onDelete()} />
      </div>
    )
  }
}
